import { FC } from "react";

interface PersonProps {
  color?: string;
  size?: number;
}

const PersonID: FC<PersonProps> = ({ size = 35, color = "#51C2B9" }) => {
  return (
    <>
      <svg
        className={`min-w-${size}px`}
        width={size}
        height={size}
        viewBox="0 0 35 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.7083 4.8737H21.6125C21 3.18203 19.3958 1.95703 17.5 1.95703C15.6042 1.95703 14 3.18203 13.3875 4.8737H7.29167C5.6875 4.8737 4.375 6.1862 4.375 7.79036V28.207C4.375 29.8112 5.6875 31.1237 7.29167 31.1237H27.7083C29.3125 31.1237 30.625 29.8112 30.625 28.207V7.79036C30.625 6.1862 29.3125 4.8737 27.7083 4.8737ZM17.5 4.8737C18.3021 4.8737 18.9583 5.52995 18.9583 6.33203C18.9583 7.13411 18.3021 7.79036 17.5 7.79036C16.6979 7.79036 16.0417 7.13411 16.0417 6.33203C16.0417 5.52995 16.6979 4.8737 17.5 4.8737ZM17.5 10.707C19.9208 10.707 21.875 12.6612 21.875 15.082C21.875 17.5029 19.9208 19.457 17.5 19.457C15.0792 19.457 13.125 17.5029 13.125 15.082C13.125 12.6612 15.0792 10.707 17.5 10.707ZM26.25 28.207H8.75V26.1654C8.75 23.2487 14.5833 21.6445 17.5 21.6445C20.4167 21.6445 26.25 23.2487 26.25 26.1654V28.207Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default PersonID;
